import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-informativo",
  templateUrl: "./informativo.component.html",
  styleUrls: ["./informativo.component.scss"],
})
export class InformativoComponent implements OnInit {
  titulo: string = "INFORMATIVO";

  constructor() {}

  ngOnInit(): void {}
}
